export default class APIRoutes {
    public static readonly GET_API_CONTEXT = '/initialize';
    public static readonly IDP_USER_CONTEXT = '/idp-user-context';
    public static readonly WELCOME_DATA= '/pre-hire/welcome-data';
    public static readonly GET_OTP_DESTINATIONS= '/pre-hire/get-otp-destinations';
    public static readonly SEND_RESET_PIN= '/pre-hire/send-reset-pin';
    public static readonly SET_PASSWORD= '/pre-hire/set-password';
}
